import React from 'react';
import faqData from '../../cms/faq.json';
import pageIntros from '../../cms/page-intros.json';
import PageChrome from '../../components/layout/PageChrome';
import FAQCard from '../../components/cards/FAQCard';
import RichText from '../../components/ui/RichText';
import '../../css/about/FAQ.css';

const intro = pageIntros.faq || {};

const FAQ = () => {
  return (
    <div className="faq-page">
      <PageChrome
        title={intro.title}
        subtitle={intro.subtitle}
        intro={intro.intro}
      >
        <div className="faq-container">
          <div className="faq-grid">
            {faqData.map((faq) => (
              <FAQCard key={faq.id} faq={faq} />
            ))}
          </div>

          <div className="faq-contact">
            <RichText value={intro.contact} />
          </div>
        </div>
      </PageChrome>
    </div>
  );
};

export default FAQ;
